// extracted by mini-css-extract-plugin
export default {"raiz":"EmptyState_raiz__KePLQ","circulo":"EmptyState_circulo__xXeq5","titulo":"EmptyState_titulo__tgs5L","descricao":"EmptyState_descricao__Pg8MA","acao":"EmptyState_acao__Rk17t"};